/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingProvisionalConfig } from '../../config/loading.config';
export interface ILoadingProvisionalPluginMethods extends IPluginMethodMap {
  getLoadingProvisionalSync(args?: any): any;
}

export class LoadingProvisionalPlugin implements IAgentPlugin {
  readonly methods: ILoadingProvisionalPluginMethods;

  constructor() {
    this.methods = {
      getLoadingProvisionalSync: this.getLoadingProvisionalSync.bind(this),
    };
  }

  getLoadingProvisionalSync(args?: any) {
    return {
      loading: loadingProvisionalConfig,
    };
  }
}
